import '.k{display:grid;}.ssr-plugin'
import '.i{gap:1.5rem;}.ssr-plugin'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useTranslations } from '@i18n/useLanguage'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import { pages } from '@app/util/links'
import { labelAddressBuilder } from '@app/util/helpers'
import { Empty } from '@app/components/blocks/empty/Empty'
import BuilderImage from '@app/assets/images/builder.png'

export const HousingFormPageInitiatives = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  if (!housingForm?.initiatives || housingForm.initiatives.length === 0) {
    return (
      <Empty
        title={t.housingFormPage.noInitiativesTitle}
        imageSrc={BuilderImage}
        ctaLabel={t.housingFormPage.noInitiativesCta}
        ctaLink={pages.dashboardStartInitiative}
      >
        {t.housingFormPage.noInitiativesDescription}
      </Empty>
    )
  }

  return (
    <div className="k i"
      style={{
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      }}
    >
      {housingForm?.initiatives?.map((initiative) => (
        <InitiativeCard
          key={initiative.id}
          to={pages.initiative(initiative.slug)}
          image={initiative.images?.[0]?.src ?? defaultProjectPicture}
          title={initiative.title}
          description={initiative.description}
          location={labelAddressBuilder(
            initiative.location.address,
            t.common.notSpecified,
          )}
          phase={initiative.phase?.name}
          tagText={
            initiative.searchingForMembers
              ? t.common.initiativeStatus.searchingForMembers
              : t.common.initiativeStatus.notSearchingForMembers
          }
          tagVariant={initiative.searchingForMembers ? 'success' : 'neutral'}
        />
      ))}
    </div>
  )
}
